import { render, staticRenderFns } from "./GAuthPasswordForm.vue?vue&type=template&id=0288c423&"
import script from "./GAuthPasswordForm.vue?vue&type=script&lang=ts&"
export * from "./GAuthPasswordForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports